import React from "react";

const TransSummaryComp = ({ sum }) => {
  return (
    <div className={` ${sum?.conClass}`}>
      <div className="flex flex-col ">
        <div className={sum?.labelClass}>{sum?.label}</div>
        <p className={sum?.valueClass}>{sum?.value}</p>
        <p className={`${sum?.descClass} mt-2`}>{sum?.desc}</p>
      </div>{" "}
      <div>{sum?.icon}</div>
    </div>
  );
};

export default TransSummaryComp;
